import { normalizarStatus } from "../constants/statusPedido";

/*
 * Fonte única de verdade do pagamento de um pedido.
 *
 * pedido.pagamentos: [{ id, valor, metodo, em, por }]  ← novo modelo (parciais)
 *
 * Compatível com dados antigos:
 *  - sem array, mas com sinal_pago ("50%"/"100%") -> converte em fração do total
 *  - sem nada, mas já "entregue" -> assume quitado (mantém faturamento histórico)
 *
 * Regra do negócio: o recebido NUNCA passa do total do pedido
 * (um pedido de R$100 nunca soma R$150 no financeiro).
 */

function fracaoSinal(sinal) {
  if (!sinal) return null;
  const m = String(sinal).match(/(\d+(?:\.\d+)?)/);
  if (!m) return null;
  const pct = parseFloat(m[1]);
  if (isNaN(pct)) return null;
  return Math.max(0, Math.min(1, pct / 100));
}

export function calcPagamento(pedido) {
  const total = parseFloat(pedido?.valor) || 0;
  let pago = 0;
  if (Array.isArray(pedido?.pagamentos)) {
    pago = pedido.pagamentos.reduce((s, p) => s + (parseFloat(p?.valor) || 0), 0);
  } else {
    const frac = fracaoSinal(pedido?.sinal_pago);
    if (frac != null) pago = total * frac;
    else if (normalizarStatus(pedido?.status) === "entregue") pago = total;
  }
  const recebido = total > 0 ? Math.min(pago, total) : pago;
  const saldo = Math.max(0, total - pago);
  const quitado = (total > 0 && pago >= total - 0.005) || (total === 0 && !!pedido?.cupom && pedido.desconto > 0);
  const pct = total > 0 ? Math.min(100, Math.round((pago / total) * 100)) : quitado ? 100 : 0;
  return { total, pago, recebido, saldo, quitado, pct };
}
